<template>
  <div>
    <v-row style="padding-right: 50px">
      <v-col
        cols="12"
        sm="4"
        md="2"
      >
        <datepicker-input
          v-model="month"
          format="MMMM"
          display="month"
          type="month"
          label="Month"
        />
      </v-col>
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-btn-toggle
          mandatory
          :value="view"
           @change="$emit('update:view',$event)"
        >
          <v-btn>Month</v-btn>
          <v-btn>Week</v-btn>
          <v-btn>Day</v-btn>
          <v-btn></v-btn>
        </v-btn-toggle>
      </v-col>
      <!--      <v-col>-->
      <!--        <v-btn @click="currentDate = new Date()">-->
      <!--          Today-->
      <!--        </v-btn>-->
      <!--      </v-col>-->
      <v-col
        cols="12"
        sm="6"
        md="3"
      >
        <v-row v-if="view===1">
          <v-btn @click="decWeek">
            -
          </v-btn>
          <v-btn @click="incWeek">
            +
          </v-btn>
        </v-row>

        <v-row v-if="view===2">
          <v-btn @click="decDate">
            -
          </v-btn>
          <datepicker-input
            :value="currentDate"
            label="Pick Date"
            @input="log"
          />
          <v-btn @click="incDate">
            +
          </v-btn>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="3"
      >
        <datepicker-input
          style="width: 250px;"
          :value="customDates"
          range
          format="MMM DD"
          @input="vals=>customDate(vals)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import DatepickerInput from '../../../components/base/DatepickerInput'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  // const companySettings = JSON.parse(localStorage.getItem('companyFull')) && JSON.parse(localStorage.getItem('companyFull')).settings
  import Conversion from '@/helpers/ZemenCalendar/conversion'
  export default {
    name: 'ViewSelector',
    components: { DatepickerInput },
    props: {
      view: {
        type: Number,
        required: true,
      },
      currentDate: {
        type: Date,
        default: new Date(),
      },
    },

    data: () => ({
      selectedMember: 0,
      month: new Date(),
      // currentDate: new Date(),
      startDateM: '', // moment().startOf('month').add((companySettings && companySettings.offsetDays) || 0, 'days').toDate(),
      endDateM: '', // moment.min(moment(),moment().endOf('month').add((companySettings && companySettings.offsetDays) || 0, 'days').toDate()).toDate(),

      //        view: 0,
      // week: moment(new Date()).get('w'),
      // startDate: moment().startOf('month').toDate(),
      // endDate: moment().endOf('month').toDate(),
    }),
    computed: {
      ...mapGetters([
        'companySettings',
      ]),
      customDates () {
        return [moment(this.startDate).format('YYYY-MM-DD'), moment(this.endDate).format('YYYY-MM-DD')]
      },
      startDate () {
        let date
        if (this.view === 0) { // month
          if (this.companySettings && this.companySettings.calendar === 'EC') {
            const today = moment.utc(this.currentDate)
            const todayEc = Conversion.toEC([today.get('year'), today.get('month') + 1, today.get('date')])
            const [yyyy, mm, dd] = Conversion.toGC([todayEc[0], todayEc[1], 1])
            date = moment([yyyy, mm - 1, dd]).add((this.companySettings && this.companySettings.offsetDays) || 0, 'days').toDate()
            this.startDateM = date
          } else {
            date = moment(this.currentDate).startOf('month').add((this.companySettings && this.companySettings.offsetDays) || 0, 'days').toDate()
            this.startDateM = date
          }
        } else if (this.view === 1) // week
        {
          date = moment(this.currentDate).startOf('week').toDate()
          this.startDateM = date
        } else if (this.view === 2) // day
        {
          date = moment(this.currentDate).startOf('day').toDate()
        } else if (this.view === 3) // custom
        {
          date = this.startDateM
        }
        this.$emit('startDate', date)
        return date
      },
      endDate () {
        let date
        if (this.view === 0) {
          if (this.companySettings && this.companySettings.calendar === 'EC') {
            date = moment(this.startDate).add(29, 'day')
            this.endDateM = date
          } else {
            date = moment(this.startDate).add(moment(this.currentDate).daysInMonth()-1, 'day')
            this.endDateM = date
          }
        } else if (this.view === 1) // week
        {
          date = moment(this.currentDate).endOf('week').toDate()
          this.endDateM = date
        } else if (this.view === 2) // day
        {
          date = moment(this.currentDate).endOf('day').toDate()
        } else if (this.view === 3) // custom
        {
          date = this.endDateM
        }
        this.$emit('endDate', date)
        return date
      },
    },
    // created() {
    //     this.view = this.defaultView || 0
    // },

    watch: {

      month: function (val) {
        // console.log(val)
        this.$emit('update:view', 0)
        this.$emit('update:currentDate', this.companySettings && this.companySettings.calendar === 'EC' ? moment(val).startOf('month').add(15, 'day').toDate() : moment(val).startOf('month').toDate())
        // this.$emit('endDate', moment(val).endOf('month'))
        // this.currentDate = val
      },

      // week: function (val) {
      //
      //   console.log(val)
      //
      //   this.currentDate = moment(this.month).set('week',val).toDate()
      //
      // }
    },
    mounted () {
      const offset = (this.companySettings && this.companySettings.offsetDays) || 0
      const startOfMonth = moment().startOf('month').add(offset, 'days')
      const endOfMonth = moment().endOf('month').add(offset, 'days')
      this.startDateM = startOfMonth.toDate()
      this.endDateM = moment.min(moment(), endOfMonth).toDate()
    },
    methods: {
      log (ev) {
        // console.log("currentDate",ev)
        this.$emit('update:currentDate', moment(ev).toDate())
      },
      incWeek () {
        this.$emit('update:currentDate', moment(this.currentDate).add(1, 'w').toDate())
        // this.currentDate = moment(this.currentDate).add(1, 'w').toDate()
      },
      decWeek () {
        this.$emit('update:currentDate', moment(this.currentDate).add(-1, 'w').toDate())
        // this.currentDate = moment(this.currentDate).add(-1, 'w').toDate()
      },
      incDate () {
        this.$emit('update:currentDate', moment(this.currentDate).add(1, 'd').toDate())
        // this.currentDate = moment(this.currentDate).add(1, 'd').toDate()
      },
      decDate () {
        this.$emit('update:currentDate', moment(this.currentDate).add(-1, 'd').toDate())
        // this.currentDate = moment(this.currentDate).add(-1, 'd').toDate()
      },
      customDate (vals) {
        //    console.log("view",this.view)
        if (!vals || !Array.isArray(vals) || vals.length < 2) return
        this.$emit('update:view', 3)
        const start = moment(vals[0])
        const end = moment(vals[1])
        if (start.isValid()) this.startDateM = start.toDate()
        if (end.isValid()) this.endDateM = end.toDate()
      },

    },
  }
</script>

<style scoped>

</style>
